import type * as Immutable from 'immutable';
import { createMigration } from './utils';

const NEW_Y_POSITIONS_BY_ASPECT_RATIO: Record<string, number> = {
    landscape: 970,
    vertical: 1340,
    square: 950,
    fourfive: 1220,
};

export const migrationTo9_224 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('slides').forEach((scene: Immutable.Map<string, unknown>, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        const sceneDesignId = scene.get('sceneDesign') as string | undefined;
        if (!sceneDesignId || !sceneDesignId.includes('caption_')) {
            return scene;
        }

        const aspectRatio = scene.get('aspectRatio') as string;
        const newYPosition = NEW_Y_POSITIONS_BY_ASPECT_RATIO[aspectRatio];
        const newYAnchor = 0.5;

        return scene.withMutations((map) => {
            map.get('children', []).forEach((_child: unknown, cIndex: number) => {
                const path = ['children', cIndex];
                const asset = map.getIn(path) as Immutable.Map<string, unknown> | undefined;
                if (!asset) {
                    return;
                }

                const childClassType = asset.get('classType');
                if (
                    childClassType !== 'CanvasFancyCaptionAsset' &&
                    childClassType !== 'CanvasCaptionAsset'
                ) {
                    return;
                }

                map.setIn([...path, 'transformation', 'anchor', 'y'], newYAnchor);

                if (newYPosition !== undefined) {
                    map.setIn([...path, 'transformation', 'position', 'y'], newYPosition);
                }
            });
        });
    },
});
